<template>
  <div class="footer">
    <footer class="wrap-width">
      <span class="footerText"
        >&copy; Katie Miles {{ new Date().getFullYear() }}</span
      >
    </footer>
  </div>
</template>